import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('bottom-bar-one', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 20H17C17 20 24 27.28 24 34C24 40.72 18 44 18 44H12C12 44 6 40.72 6 34C6 27.28 13 20 13 20Z",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4C17.0833 4 20 5.52 20 10C20 14.48 16.6667 20 16.6667 20H13.3333C13.3333 20 10 14.48 10 10C10 5.52 12.9167 4 15 4Z",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 20H35C35 20 42 27.28 42 34C42 40.72 36 44 36 44H30C30 44 24 40.72 24 34C24 27.28 31 20 31 20Z",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 4C35.0833 4 38 5.52 38 10C38 14.48 34.6667 20 34.6667 20H31.3333C31.3333 20 28 14.48 28 10C28 5.52 30.9167 4 33 4Z",
    fill: props.colors[1],
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});